module.exports = __webpack_public_path__ + "static/Kaizen_Corredor_Norte_Monitoramento-ca99d47303ba8dd68cc9d6445a325186.png";